<mat-card class="size flex-around-center " style="display: flex;flex-flow: column;">
  <div class="flex-around-center flex-direction-column w100">
    <div class="flex-center-center w100">
      <div class="width-currentValue flex-around-center flex-direction-row w100">
        @if (currentUmidity|isSet:'number') {
          <div class="size-card-currentValue text-color-primary">
            <div class="size-card-currentValue  flex-around-center flex-direction-row w100">
              <button mat-icon-button>
                <mat-icon svgIcon="dropPlusMinus"></mat-icon>
              </button>
              <h3 style="margin: 0">{{currentUmidity}} %</h3>
            </div>
          </div>
        }
        @if (currentMode) {
          <div class="size-card-currentValue text-color-accent">
            <div class="size-card-currentValue  flex-around-center flex-direction-row w100">
              <h3 style="margin: 0;padding: 0px 4px;    border-radius: 3px;    border: 1px solid;">{{currentMode}}</h3>
            </div>
          </div>
        }
      </div>
      <div class="flex-center-center" style="height: 40px;">
        <button mat-icon-button (click)="openSettings()">
          <mat-icon>settings</mat-icon>
        </button>
      </div>
    </div>
    <mat-card
      matRipple
      [matRippleCentered]="true"
      [matRippleRadius]="90"
      (click)="openThermostat('')"
      class="size-card-settingValue background-color-purple-gradient-circle flex-direction-column cursor"
      style="display: flex;justify-content: center;align-items: center">
      @if (settingTemperature|isSet:'number') {
        <h1 style="margin: 0 0 -5px 0;color: white;font-size: xx-large">{{settingTemperature}}<sup
        style="font-size: x-small">°C</sup></h1>
        @if (currentTemperature) {
          <h3 style="color: white;margin: 0">{{currentTemperature}}<sup
          style="font-size: xx-small">°C</sup></h3>
        }
      } @else {
        @if (currentTemperature|isSet:'number') {
          <h1 style="color: white;font-size: xx-large;margin: 0"
            >{{currentTemperature}}<sup
          style="font-size: xx-small">°C</sup></h1>
        }
      }
    </mat-card>
    @if (loadValue) {
      <mat-spinner diameter="40" style="position: absolute;transform: translatey(-11px)"
      ></mat-spinner>
    }
    @if (title) {
      <h2 style="margin: 0;max-height: 64px;overflow: auto">
        {{title}}
      </h2>
    }
  </div>
  <div class="width-currentValue flex-between-center flex-direction-row w100">
    <div class="size-card-currentValue text-color-primary">
      <div class="size-card-currentValue  flex-around-center flex-direction-row w100">
        <ng-content select="[button]">
        </ng-content>
      </div>
    </div>
  </div>
</mat-card>